export const ClpHeaderBarSkeleton = () => {
  return (
    <div className={'flex h-spacing-120 items-center justify-between gap-spacing-12 px-spacing-20 sm:px-spacing-0'}>
      <div
        className={'h-spacing-64 w-spacing-180 animate-pulse rounded-md bg-gray-300 sm:w-spacing-220 md:w-spacing-260'}
      />
      <div className={'ml-auto mr-spacing-4 flex size-spacing-44 items-center justify-center sm:size-spacing-56'}>
        <div className={'size-spacing-32 animate-pulse rounded-radius-md bg-gray-300'} />
      </div>
    </div>
  )
}
